// extracted by mini-css-extract-plugin
export default {"container":"ContainerDocumentation_container__+1RlW","propertyDivider":"ContainerDocumentation_propertyDivider__nvQNe","warning":"ContainerDocumentation_warning__i-ySK"};